// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-bdtjcx-nhgsBdtjcx-index-main_right_content-2hkpa","table":"components-tjcx-bdtjcx-nhgsBdtjcx-index-table-1-nIs"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/bdtjcx/nhgsBdtjcx/index.css
// module id = 215
// module chunks = 0